import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Persisted view-mode preference for the Courses list (CLAUDE.md §2.3),
 * mirroring the CRM/HRM list stores. Search/filter live in URL-bound page
 * state and stay out of the store — those are server-driven query params, not
 * durable user prefs.
 */
export type CoursesViewMode = 'table' | 'list' | 'cards' | 'grouped';

export const COURSES_VIEW_MODES: CoursesViewMode[] = ['table', 'list', 'cards', 'grouped'];

interface CoursesUiState {
  view: CoursesViewMode;
  setView: (view: CoursesViewMode) => void;
  /** Current DRF `OrderingFilter` value (e.g. `-created`). Session-only. */
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const useCoursesUi = create<CoursesUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'lms.courses:ui',
      // Only the view mode is durable — ordering stays ephemeral so refreshes
      // return to a clean default.
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
